<script>
import { useRouter } from 'vue-router';

import { ChevronLeftIcon } from '@thehotelsnetwork/icons/vue/linear';

import { track } from '@/utils/analytics';

export default {
  components: {
    ChevronLeftIcon,
  },
  props: {
    route: {
      type: String,
      default: '',
    },
    disableLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();
    const handleBackBtn = () => {
      if (props.route) {
        track(`back to - ${props.route}`);
        router.push(props.route);
      } else {
        router.go(-1);
      }
    };
    return {
      handleBackBtn,
    };
  },
};
</script>

<template>
  <div>
    <div class="flex">
      <LpBasicLink
        v-if="!disableLink"
        class="flex items-center"
        @click="handleBackBtn"
      >
        <ChevronLeftIcon class="w-4 h-4 mr-3" />
        <div class="text-sm font-medium">
          <slot name="back-text" />
        </div>
      </LpBasicLink>
    </div>
    <slot name="content" />
  </div>
</template>
